import styled, { css } from 'styled-components';
import { WrapperProps } from './types';

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme: { spacing, border, color }, $checked, $disabled }) => css`
    display: flex;
    align-items: center;
    gap: ${spacing.km1};
    padding: ${spacing.km6} ${spacing.km4} ${spacing.km6} ${spacing.km8};
    border: ${border.width.thinner} ${border.style.solid};
    border-color: ${$checked ? color.border.neutral.strong : color.border.neutral.default};
    border-radius: ${border.radius.large};
    transition: border-color 0.2s ease-in-out;
    cursor: pointer;

    ${$disabled &&
    css`
      cursor: not-allowed;
      background-color: ${color.background.neutral.weak};
    `}
  `}
`;

export const PartnerContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.km1};
  `}
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 18rem;
  height: 22px;

  img {
    height: auto;
    width: auto;
    max-width: 100px;
    max-height: 22px;
  }
`;
